export interface Riddle {
  id: string;
  category: string;
  question: string;
  answer: string;
  hint?: string;
}

export const riddles: Riddle[] = [
  {
    id: '1',
    category: '动物',
    question: '忠诚伴主旁，夜半守门忙，闻声即警觉，摇尾迎客常。',
    answer: '狗',
    hint: '人类最忠实的朋友'
  },
  {
    id: '2',
    category: '动物',
    question: '夜行无声影，眼如夜明珠，爪利能攀树，家中有它无鼠。',
    answer: '猫',
    hint: '喜欢捉老鼠的宠物'
  },
  {
    id: '3',
    category: '动物',
    question: '身躯如山岳，长鼻似巨蟒，耳大如蒲扇，行走稳如钟。',
    answer: '大象',
    hint: '非洲草原上最大的陆地动物'
  },
  {
    id: '4',
    category: '动物',
    question: '山中称大王，额上写王字，吼声震山林，百兽皆避之。',
    answer: '老虎',
    hint: '丛林之王'
  },
  {
    id: '5',
    category: '动物',
    question: '头戴金冠威风凛，身披黄袍气势雄，一声吼叫震山林，百兽闻声皆避走。',
    answer: '狮子',
    hint: '草原之王'
  },
  {
    id: '6',
    category: '动物',
    question: '高耸入云非楼阁，颈长如柱望天涯，斑纹点缀身如画，草原漫步显优雅。',
    answer: '长颈鹿',
    hint: '脖子很长的动物'
  },
  {
    id: '7',
    category: '动物',
    question: '黑白条纹身上披，草原奔跑如风驰，不是马儿却似马，群居生活乐无比。',
    answer: '斑马',
    hint: '有黑白条纹的马'
  },
  {
    id: '8',
    category: '动物',
    question: '四蹄踏风尘，鬃毛随风扬，日行千里路，忠诚伴主旁。',
    answer: '马',
    hint: '曾经是重要的交通工具'
  }
]; 